/**
 * Desktop dual-line (≥ 990px): logo 2 linhas + categorias alinhadas com Showroom.
 * Mobile/tablet: não altera layout (reset via CSS + clearVars).
 */
(function () {
  const ROOT_SEL = '#header-group.andrade-header--single-line:not(.andrade-header--centered)';
  const MIN_W = 990;

  const clearMobile = (root) => {
    if (!root) return;
    root.style.removeProperty('--andrade-header-dual-h');
    root.style.removeProperty('--andrade-header-bar-h');
    root.style.removeProperty('--andrade-header-categories-start');
    root.style.removeProperty('--andrade-header-utility-offset');
    root.style.removeProperty('--andrade-header-logo-rail-w');
    root.style.removeProperty('--andrade-header-logo-inset');
    root.style.removeProperty('--andrade-header-row2-pull');
    root.classList.remove('andrade-header--logo-rail-ready');

    const navInner = root.querySelector('.andrade-header-dual-row2 .header-categories-nav__inner');
    if (navInner) {
      navInner.style.removeProperty('padding-inline-start');
    }
  };

  const measureLogoWidth = (img) => {
    const h = img.getBoundingClientRect().height;
    if (img.naturalWidth > 0 && img.naturalHeight > 0 && h > 0) {
      return Math.round((img.naturalWidth / img.naturalHeight) * h);
    }
    return Math.round(img.getBoundingClientRect().width);
  };

  const sync = () => {
    const root = document.querySelector(ROOT_SEL);
    if (!root) return;

    if (window.innerWidth < MIN_W) {
      clearMobile(root);
      return;
    }

    const headerRow = root.querySelector('.header__row--top');
    const utilityAnchor = root.querySelector(
      '.header-categories-nav--utility .header-categories-nav__list > li:first-child a, .header-categories-nav--utility .header-categories-nav__details > summary'
    );
    const categoryAnchor = root.querySelector(
      '.andrade-header-dual-row2 .header-categories-nav__list > li:first-child a, .andrade-header-dual-row2 .header-categories-nav__details > summary'
    );
    const row2 = root.querySelector('.andrade-header-dual-row2');
    const navInner = row2?.querySelector('.header-categories-nav__inner');
    const logoTopImg = root.querySelector('.header__column--left .andrade-logo__img--top');
    const logoBand = root.querySelector('.andrade-header-categories--desktop-band');

    if (logoTopImg && logoBand) {
      const logoRect = logoTopImg.getBoundingClientRect();
      const bandRect = logoBand.getBoundingClientRect();
      const bandPadLeft = parseFloat(getComputedStyle(logoBand).paddingLeft) || 0;
      const logoW = measureLogoWidth(logoTopImg);

      if (logoW > 0) {
        root.style.setProperty('--andrade-header-logo-rail-w', `${logoW}px`);

        const leftInset = Math.round(logoRect.left - (bandRect.left + bandPadLeft));
        root.style.setProperty('--andrade-header-logo-inset', `${Math.max(0, leftInset)}px`);
        root.classList.add('andrade-header--logo-rail-ready');
      }
    } else {
      root.style.removeProperty('--andrade-header-logo-rail-w');
      root.style.removeProperty('--andrade-header-logo-inset');
      root.classList.remove('andrade-header--logo-rail-ready');
    }

    if (headerRow && row2) {
      const row1H = Math.round(headerRow.getBoundingClientRect().height);
      if (row1H > 0) {
        root.style.setProperty('--andrade-header-bar-h', `${row1H}px`);
      }
    }

    const utilityInner = root.querySelector('.header-categories-nav--utility .header-categories-nav__inner');
    const categoryInner = root.querySelector('.andrade-header-dual-row2 .header-categories-nav__inner');

    root.style.setProperty('--andrade-header-categories-start', '0px');

    if (utilityInner && categoryInner) {
      const prevOffset = parseFloat(getComputedStyle(root).getPropertyValue('--andrade-header-utility-offset')) || 0;
      const utilLeft = utilityInner.getBoundingClientRect().left - prevOffset;
      const catLeft = categoryInner.getBoundingClientRect().left;
      const delta = Math.round(catLeft - utilLeft);
      root.style.setProperty('--andrade-header-utility-offset', `${delta}px`);
    } else if (utilityAnchor && categoryAnchor) {
      const prevOffset = parseFloat(getComputedStyle(root).getPropertyValue('--andrade-header-utility-offset')) || 0;
      const utilLeft = utilityAnchor.getBoundingClientRect().left - prevOffset;
      const catLeft = categoryAnchor.getBoundingClientRect().left;
      const delta = Math.round(catLeft - utilLeft);
      root.style.setProperty('--andrade-header-utility-offset', `${delta}px`);
    } else {
      root.style.removeProperty('--andrade-header-utility-offset');
    }

    /* Puxa linha 2 para cima (transform) — não altera logo/busca da linha 1 */
    const utilityRail = root.querySelector(
      '.header-categories-nav--utility .header-categories-nav__list, .header-categories-nav--utility .header-categories-nav__inner'
    );
    const categoryRail = root.querySelector(
      '.andrade-header-dual-row2 .header-categories-nav__list, .andrade-header-dual-row2 .header-categories-nav__inner'
    );

    if (utilityRail && categoryRail) {
      const utilBottom = utilityRail.getBoundingClientRect().bottom;
      const catTop = categoryRail.getBoundingClientRect().top;
      const seamTarget = 0;
      const pull = Math.max(0, Math.round(catTop - utilBottom - seamTarget));
      if (pull > 0) {
        root.style.setProperty('--andrade-header-row2-pull', `${pull}px`);
      } else {
        root.style.removeProperty('--andrade-header-row2-pull');
      }
    } else {
      root.style.removeProperty('--andrade-header-row2-pull');
    }
  };

  const schedule = () => {
    window.requestAnimationFrame(() => {
      sync();
      window.requestAnimationFrame(() => {
        sync();
        window.requestAnimationFrame(sync);
      });
    });
  };

  let resizeTimer;
  const onResize = () => {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(schedule, 80);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }

  window.addEventListener('resize', onResize, { passive: true });
  window.addEventListener('load', schedule);
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:reorder', schedule);

  if (document.fonts?.ready) {
    document.fonts.ready.then(schedule).catch(() => {});
  }

  const logoImgs = document.querySelectorAll(
    `${ROOT_SEL} .header__column--left .andrade-logo__img--top, ${ROOT_SEL} .andrade-header-logo-bottom__img`
  );
  logoImgs.forEach((img) => {
    if (!img.complete) {
      img.addEventListener('load', schedule, { once: true });
    }
  });

  /** Mobile: coração legado com href /search → abre modal em vez de redirecionar */
  const bindMobileSearchIcon = () => {
    if (window.innerWidth > 749) return;

    const legacyLink = document.querySelector(
      '#header-group header-actions > a.andrade-wishlist-link:not(.andrade-wishlist-link--desktop-only)'
    );
    if (!legacyLink || legacyLink.dataset.andradeSearchBound === '1') return;

    legacyLink.dataset.andradeSearchBound = '1';
    legacyLink.addEventListener('click', (event) => {
      const modal = document.getElementById('search-modal');
      if (!modal || typeof modal.showDialog !== 'function') return;
      event.preventDefault();
      modal.showDialog();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindMobileSearchIcon);
  } else {
    bindMobileSearchIcon();
  }

  document.addEventListener('shopify:section:load', bindMobileSearchIcon);
})();
